import Upload from "../../../../src/mdx/api/endpoints/upload.mdx";
import * as React from 'react';
export default {
  Upload,
  React
};